import React from 'react';

function Project() {
  return (
      <section className="tc-project-style1 header">
        <div className="main-info">
          <div className="container">
            <div className="tags mb-50">
              <a href="#"> Konut </a>
              <a href="#"> Modern Yaşam </a>
            </div>
            <h1 className="title"> Yamaçtepe Konutları </h1>
            <div className="text color-666 mt-30">
              Gaziantep Yamaçtepe bölgesinde, şehir hayatını doğayla buluşturan çağdaş apartman daireleri. <br />
              Konforlu, güvenli ve toplu yaşama uygun yeni nesil bir konut projesi.
            </div>
          </div>
        </div>

        <div className="main-img">
          <img
              src="/innerpages/assets/img/projects/yamactepe/gündüz_11%20-%20Foto-min.jpg"
              alt="Yamaçtepe Apartmanları Ana Görsel"
              className="img-cover"
              data-speed="1.25"
          />
        </div>

        <div className="description">
          <div className="container">
            <h3 className="sub-title fsz-45 mb-60 wow fadeInUp slow" data-wow-delay="0.2s">
              Proje Açıklaması
            </h3>
            <div className="text fsz-24 mb-20 fw-500 wow fadeInUp slow" data-wow-delay="0.2s">
              Yamaçtepe’nin yükselen bölgesinde konumlanan bu apartman projesi, ailelerin ve bireylerin konforlu yaşamı için özel olarak tasarlandı. Geniş balkonlar, otopark alanları ve modern daire planları ile dikkat çekiyor.
            </div>
            <div className="text fsz-24 fw-500 wow fadeInUp slow" data-wow-delay="0.2s">
              Projede güvenlik, sosyal alanlar, çocuk parkı ve yürüyüş yolları gibi detaylarla sosyal yaşam desteklenirken, her dairede gün ışığını maksimum alan planlama ile ferahlık ön planda tutuldu.
            </div>
          </div>

          <div className="services">
            <div className="container">
              <div className="row">
                <div className="col-lg-7">
                  <div className="items flex align-items-center">
                    <div className="row">
                     {/* <div className="col-lg-6">
                        <div className="item mt-100 wow fadeInUp slow" data-wow-delay="0.2s">
                          <small className="d-block color-666 text-uppercase fsz-12 mb-30">
                            Hizmetler
                          </small>
                          <div className="links fsz-18 fw-500">
                            Konut Tasarımı, <br /> İç Mimarlık, Peyzaj <br /> Planlaması
                          </div>
                        </div>
                      </div>*/}
                      <div className="col-lg-6">
                        <div className="item mt-100 wow fadeInUp slow" data-wow-delay="0.4s">
                          <small className="d-block color-666 text-uppercase fsz-12 mb-30">
                            Lokasyon
                          </small>
                          <div className="links fsz-18 fw-500">
                            Yamaçtepe, Gaziantep <br /> Türkiye
                          </div>
                        </div>
                      </div>
                     <div className="col-lg-6">
                        <div className="item mt-100 wow fadeInUp slow" data-wow-delay="0.2s">
                          <small className="d-block color-666 text-uppercase fsz-12 mb-30">
                            İnşaat Alanı
                          </small>
                          <div className="links fsz-18 fw-500">
                            9000 m2
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="item mt-100 wow fadeInUp slow" data-wow-delay="0.4s">
                          <small className="d-block color-666 text-uppercase fsz-12 mb-30">
                            Durum
                          </small>
                          <div className="links fsz-18 fw-500">
                            Teslim Tarihi <br /> Kasım 2024
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img src="/innerpages/assets/img/projects/yamactepe/arka_33%20-%20Foto-min.jpg" alt="" className="line wow w-100 h-100 radius-3" />

          </div>

          <div className="imgs mt-120">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <div className="img th-600 radius-7 overflow-hidden mt-30 wow zoomIn slow" data-wow-delay="0.2s">
                    <img src="/innerpages/assets/img/projects/yamactepe/asalon2-min.jpg" alt="Salon Görseli" className="img-cover" />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="img th-600 radius-7 overflow-hidden mt-30 wow zoomIn slow" data-wow-delay="0.4s">
                    <img src="/innerpages/assets/img/projects/yamactepe/asalon4-min.jpg" alt="Dış Cephe" className="img-cover" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="challenge pb-120">
          {/*<div className="container">
            <h3 className="sub-title fsz-45 mb-60 wow fadeInUp slow" data-wow-delay="0.2s">
              Proje Zorlukları
            </h3>
            <div className="text fsz-24 mb-20 fw-500 wow fadeInUp slow" data-wow-delay="0.2s">
              Yamaç eğiminde konumlanan arsa üzerinde yatay mimari anlayışını bozmadan hem deprem yönetmeliğine uygun hem de ferah daireler tasarlamak gerekiyordu.
            </div>

            <ul className="dots-list fsz-18 color-666 wow fadeInUp slow" data-wow-delay="0.2s">
              <li className="d-flex my-4">
                <span className="icon me-3"> • </span> Yapı güvenliğini üst düzeyde tutarken estetikten ödün vermemek
              </li>
              <li className="d-flex my-4">
                <span className="icon me-3"> • </span> Sosyal alanlar ile bireysel mahremiyeti dengede tutmak
              </li>
              <li className="d-flex my-4">
                <span className="icon me-3"> • </span> Gün ışığından maksimum yararlanan daire planları oluşturmak
              </li>
            </ul>

            <h3 className="sub-title fsz-45 mb-60 mt-150 wow fadeInUp slow" data-wow-delay="0.2s">
              Çözüm
            </h3>
            <div className="text fsz-24 mb-20 fw-500 wow fadeInUp slow" data-wow-delay="0.2s">
              Geniş cam cepheler, modüler planlar ve çevreci malzemelerle modern bir apartman yaşamı sunuldu. Daireler enerji verimliliği sağlayan sistemlerle donatıldı. Her yaş grubuna hitap eden ortak yaşam alanları oluşturuldu.
            </div>
          </div>*/}
        </div>

        <div className="main-slider-img wow fadeInUp slow" data-wow-delay="0.2s">
          <div className="swiper-wrapper">
            {["bhol1", "bhol3", "cmutfak5", "doturmaodası1", "arka_39-Foto"].map((n) => (
                <div className="swiper-slide" key={n}>
                  <div className="img">
                    <img
                        src={`/innerpages/assets/img/projects/yamactepe/${n}-min.jpg`}
                        alt={`Yamaçtepe Görsel ${n}`}
                        className="img-cover"
                    />
                  </div>
                </div>
            ))}
          </div>
          <div className="arrows">
            <div className="swiper-button-prev"></div>
            <div className="swiper-pagination"></div>
            <div className="swiper-button-next"></div>
          </div>
        </div>
      </section>
  );
}

export default Project;